// src/components/TruckInventoryModal.js
import React, { useEffect, useState } from "react";
import "../styles/TruckInventoryModal.css";
import { useTranslation } from "react-i18next";

export default function TruckInventoryModal({
  isOpen,
  truck, // { id, plate }
  initialInventory, // { number_of_straps, number_of_ratchets, number_of_edge_protectors, number_of_anti_slip_mats }
  onClose,
  onSaveAndContinue, // (updatedInventory) => void
  isSaving = false,
}) {
  const { t } = useTranslation("truck_inventory_modal");

  const [values, setValues] = useState(initialInventory || {});

  useEffect(() => {
    setValues(initialInventory || {});
  }, [initialInventory]);

  if (!isOpen) return null;

  const setNum = (key) => (e) => {
    const v = e.target.value;
    const n = v === "" ? "" : Math.max(0, parseInt(v, 10) || 0);
    setValues((prev) => ({ ...prev, [key]: n }));
  };

  const subtitle = truck?.plate
    ? t("subtitleWithPlate", { plate: truck.plate })
    : t("subtitleNoPlate");

  return (
    <div className="truckinventory-modal-overlay" role="dialog" aria-modal="true">
      <div className="truckinventory-modal">
        {/* HEADER */}
        <div className="truckinventory-modal-header">
          <div className="truckinventory-modal-title-block">
            <div className="truckinventory-modal-title">{t("title")}</div>
            <div className="truckinventory-modal-subtitle">{subtitle}</div>
          </div>

          <button
            type="button"
            className="truckinventory-close"
            onClick={onClose}
            disabled={isSaving}
            aria-label={t("aria.close")}
            title={t("aria.close")}
          >
            ×
          </button>
        </div>

        {/* BODY */}
        <div className="truckinventory-modal-body">
          <p className="truckinventory-intro">{t("intro")}</p>

          <div className="truckinventory-fields">
            <div className="truckinventory-field">
              <label>{t("fields.straps")}</label>
              <input
                type="number"
                min="0"
                value={values.number_of_straps ?? 0}
                onChange={setNum("number_of_straps")}
                aria-label={t("fields.straps")}
              />
            </div>

            <div className="truckinventory-field">
              <label>{t("fields.ratchets")}</label>
              <input
                type="number"
                min="0"
                value={values.number_of_ratchets ?? 0}
                onChange={setNum("number_of_ratchets")}
                aria-label={t("fields.ratchets")}
              />
            </div>

            <div className="truckinventory-field">
              <label>{t("fields.edgeProtectors")}</label>
              <input
                type="number"
                min="0"
                value={values.number_of_edge_protectors ?? 0}
                onChange={setNum("number_of_edge_protectors")}
                aria-label={t("fields.edgeProtectors")}
              />
            </div>

            <div className="truckinventory-field">
              <label>{t("fields.antiSlipMats")}</label>
              <input
                type="number"
                min="0"
                value={values.number_of_anti_slip_mats ?? 0}
                onChange={setNum("number_of_anti_slip_mats")}
                aria-label={t("fields.antiSlipMats")}
              />
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="truckinventory-modal-footer">
          <button
            className="truckinventory-btn truckinventory-btn-secondary"
            onClick={onClose}
            disabled={isSaving}
            type="button"
          >
            {t("buttons.cancel")}
          </button>

          <button
            className="truckinventory-btn truckinventory-btn-primary"
            onClick={() => onSaveAndContinue(values)}
            disabled={isSaving}
            type="button"
          >
            {isSaving ? t("buttons.saving") : t("buttons.saveContinue")}
          </button>
        </div>
      </div>
    </div>
  );
}
